
export class GeneralParamModel {
    id:string;
    attributeId:string;
    name : string;
    displayName : string;
}


// WEBPACK FOOTER //
// ./src/app/modules/eldm-param-value/entities/general-param-model.ts